export default {
  text: {
    order_cancelled: 'Order canceled - Driver not available',
    wolt_support: 'Questions? Call Wolt directly <underline>{{phone_number}}</underline>',
    order_not_confirmed: '<strong>URGENT:</strong> Accept or reject this order immediately',
    no_driver_found: '<strong>No driver found.</strong> Deliver this order yourself or cancel it',
  },
  labels: {
    dummy_order: 'Test order',
    items_one: '{{count}} item',
    items_other: '{{count}} items',
    needs_acceptance: 'Needs acceptance',
    driver_pending: 'Waiting for driver',
    driver_search_retrying: 'Still searching for driver',
    no_driver_found: 'No driver found',
    today: 'Today',
    driver_assigned: 'Driver assigned',
    complete: 'Completed',
  },
  buttons: {
    complete_order: 'Mark as complete',
    looking_for_driver: 'Looking for a driver...',
    click_to_remove: 'Click to remove',
  },
};
